// extracted by mini-css-extract-plugin
module.exports =  {"category":"category-GP0hI","heading":"heading-XePFl","label":"label-N_O2v","icon":"icon-oZoyV"};